import 'primeicons/primeicons.css';
import '@/styles/demo/Demos.scss';
import '@/styles/layout/layout.scss';
import 'primereact/resources/primereact.min.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/styles.css';
import '/assets/fonts/Noto_Sans_JP/static/NotoSansJP-Regular.ttf';
import '/assets/fonts/Noto_Sans_JP/static/NotoSansJP-SemiBold.ttf';
import '/assets/fonts/Noto_Sans_JP/static/NotoSansJP-Bold.ttf';
import { PrimeReactProvider } from 'primereact/api';
import ConfigureAmplifyClientSide from '@/config/amplify-config';
import StoreProvider from './StoreProvider';
import { LayoutProvider } from '@/layout/context/layoutcontext';
import I18nProvider from '@/modules/global-components/ui/lang_translation/I18nProvider';
import { Authenticator } from '@aws-amplify/ui-react';
import { Config } from './config.tsx';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from '@/store/store';
import { ToastContextProvider } from '@/modules/global-components/ui/toast-context/ToastContextProvider';
import { Outlet } from 'react-router';
import { Toaster } from 'react-hot-toast';

const RootLayout = () => {
  ConfigureAmplifyClientSide();
  return (
    <>
      <link
        id="theme-css"
        href={`${import.meta.env.BASE_URL}themes/lara-light-teal/theme.css`}
        rel="stylesheet"
      ></link>
      <PrimeReactProvider value={{ ripple: true }}>
        <ToastContextProvider>
          <Authenticator.Provider>
            <I18nProvider>
              <StoreProvider>
                <PersistGate loading={null} persistor={persistor}>
                  <Toaster
                    containerStyle={{
                      top: 75,
                    }}
                  />
                  <LayoutProvider>
                    <Config>
                      <Outlet />
                    </Config>
                  </LayoutProvider>
                </PersistGate>
              </StoreProvider>
            </I18nProvider>
          </Authenticator.Provider>
        </ToastContextProvider>
      </PrimeReactProvider>
    </>
  );
};

export default RootLayout;
